import { client } from "../dtos/Client";
import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/from";
import * as Dtos from "../dtos/Tmd.dtos";

export const trialInstitutionItemTemplateCategoriesApi = {
    getTrialInstitutionItemTemplateCategories: (): Observable<Dtos.GetTrialInstitutionItemTemplateCategoriesResponse> => {
        //Create the request.
        let request: Dtos.GetTrialInstitutionItemTemplateCategories = new Dtos.GetTrialInstitutionItemTemplateCategories();

        //Send request.
        const response: Promise<Dtos.GetTrialInstitutionItemTemplateCategoriesResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    getTrialInstitutionItemTemplateCategoryById: (id: number): Observable<Dtos.GetTrialInstitutionItemTemplateCategoryByIdResponse> => {
        //Create the request.
        let request: Dtos.GetTrialInstitutionItemTemplateCategoryById = new Dtos.GetTrialInstitutionItemTemplateCategoryById();

        request.id = id;

        //Send request.
        const response: Promise<Dtos.GetTrialInstitutionItemTemplateCategoryByIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    setTrialInstitutionItemTemplateCategory: (trialInstitutionItemTemplateCategory: Dtos.TrialInstitutionItemTemplateCategory): Observable<Dtos.SetTrialInstitutionItemTemplateCategoryResponse> => {

        let request: Dtos.SetTrialInstitutionItemTemplateCategory = new Dtos.SetTrialInstitutionItemTemplateCategory();

        request.trialInstitutionItemTemplateCategory = trialInstitutionItemTemplateCategory;

        // send request
        const response: Promise<Dtos.SetTrialInstitutionItemTemplateCategoryResponse> = client.post(request);

        return Observable.from(response);

    },
    createTrialInstitutionItemTemplateCategory: (): Observable<Dtos.CreateTrialInstitutionItemTemplateCategoryResponse> => {
        //Create the request.
        let request: Dtos.CreateTrialInstitutionItemTemplateCategory = new Dtos.CreateTrialInstitutionItemTemplateCategory();

        //Send request.
        const response: Promise<Dtos.CreateTrialInstitutionItemTemplateCategoryResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    validateTrialInstitutionItemTemplateCategory: (trialInstitutionItemTemplateCategory: Dtos.TrialInstitutionItemTemplateCategory): Observable<Dtos.ValidateTrialInstitutionItemTemplateCategoryResponse> => {

        let request: Dtos.ValidateTrialInstitutionItemTemplateCategory = new Dtos.ValidateTrialInstitutionItemTemplateCategory();

        request.trialInstitutionItemTemplateCategory = trialInstitutionItemTemplateCategory;

        // send request
        const response: Promise<Dtos.ValidateTrialInstitutionItemTemplateCategoryResponse> = client.post(request);

        return Observable.from(response);

    }
}